// extracted by mini-css-extract-plugin
export var arbiterSwatch = "_2d-3";
export var dialog = "_2d-0";
export var divClassnameSwatch = "_2d-8";
export var flexSwatch = "_2d-4";
export var header = "_2d-1";
export var styleAttributeSwatch = "_2d-7";
export var swatch = "_2d-2";
export var textHeaderSwatch = "_2d-5";
export var webSwatch = "_2d-6";